import { render, staticRenderFns } from "./asidelist.vue?vue&type=template&id=8d20a1f8&scoped=true&"
import script from "./asidelist.vue?vue&type=script&lang=js&"
export * from "./asidelist.vue?vue&type=script&lang=js&"
import style0 from "./asidelist.vue?vue&type=style&index=0&id=8d20a1f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d20a1f8",
  null
  
)

export default component.exports